export default {
	language: 'English',
	banner_title: 'إستبيان رضى العملاء',
	banner_text1: 'في الخدمات التي نقدمها، يتم إرسال استطلاعات رضا العملاء هذا إلى مدير المشروع المكلف من قبل العميل، بشكل دوري وعند الإنتهاء من المراحل الرئيسية في المشروع.',
	banner_text2: 'تُساعدنا هذه التقارير في مراقبة العمل، وتُتيح لنا إمكانية تحسين الأداء في الوقت المناسب بغية خدمتكم بشكل أفضل.',
	banner_text3: 'شكراً لكم لتخصيص وقتكم لتعبئة هذا النموذج.',
	projectInfo_projectName: 'إسم المشروع',
	projectInfo_client: 'العميل',
	projectInfo_surveyDate: 'تاريخ الإستطلاع',
	projectInfo_projectTeamMembers: 'أفراد المشروع',
	projectInfo_projectManager: 'مدير المشروع',
	projectInfo_customerProjectManager: 'مدير المشروع - العميل',
	survey_notSatisfied: 'غير راض',
	survey_satisfied: 'راض تماماً',
	survey_filledBy: 'مملوء من قِبل',
	survey_email: 'البريد الإلكتروني',
	survey_alreadyFilled: 'لقد تم تعبئة هذا الإستبيان سابقاً',
	survey_loading: 'جاري تحميل الإستبيان...',
	survey_notFound: 'الإستبيان غير صالح'
};
